import React, { useRef } from 'react';
import { View } from 'react-native';
import './workLaunchEntrance.css';

export const WORK_LAUNCH_ENTRANCE_MS = 280;

export default function WorkLaunchEntrance({ children, startedAt, style }) {
  // Continue the same entrance when the route takes over. A quick create must
  // not restart the fade, and a slow create must not replay it at all.
  const elapsed = useRef(startedAt ? Math.max(0, Date.now() - startedAt) : WORK_LAUNCH_ENTRANCE_MS).current;
  const entering = elapsed < WORK_LAUNCH_ENTRANCE_MS;
  return <View
    dataSet={entering ? { workLaunchEntrance: '' } : undefined}
    style={[style, entering && { animationDelay: `-${elapsed}ms` }]}
  >{children}</View>;
}
